var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{on:{"click":_vm.handleUploadLog}},[_vm._v("上传日志")])
}
var staticRenderFns = []

export { render, staticRenderFns }